import { RouteRecordRaw } from 'vue-router'
import { adminAuthGuard } from '@/router/clients/cfs/cfsRouteGuards.ts'
import { ISessionStore } from '@/store/pinia/SessionStore.ts'
import { IUserStore } from '@/store/pinia/UserStore.ts'

const LoadingPage = () => import('@/views/LoadingPage.vue')
const PortalView = () => import('@/views/Clients/CFS/PortalView.vue')
const CallcentrePortalAdminTable = () =>
  import('@/components/CallcentrePortal/Variants/CFS/CallcentrePortalAdminTable.vue')
const GuidanceClientSearchConfirm = () =>
  import('@/components/CFS/Guidance/GuidanceClientSearchConfirm.vue')
const MemberInfoForm = () => import('@/components/CFS/Guidance/MemberInfoForm.vue')
const CallcentrePortalMemberVerification = () =>
  import('@/components/CallcentrePortal/CallcentrePortalMemberVerification.vue')
const CFSBackOfficeReports = () => import('@/components/CFS/CFSBackOfficeReports.vue')
const CallcentrePortalReporting = () =>
  import('@/components/CallcentrePortal/CallcentrePortalReporting.vue')
const CallcentrePortalOverview = () =>
  import('@/components/CallcentrePortal/CallcentrePortalOverview.vue')
const CallcentrePortalEngagement = () =>
  import('@/components/CallcentrePortal/CallcentrePortalEngagement.vue')

export default (sessionStore: ISessionStore, userStore: IUserStore): Array<RouteRecordRaw> => {
  return [
    {
      path: '/admin',
      name: 'adminLogin',
      component: LoadingPage,
      beforeEnter: () => {
        sessionStore.login('Username-Password-Authentication')
      },
    },
    {
      path: '/admin-portal',
      redirect: '/admin-portal/search-users',
      component: PortalView,
      beforeEnter: (to, from, next) => adminAuthGuard(to, from, next, userStore, sessionStore),
      children: [
        // callcenter portal start
        {
          path: 'home',
          name: 'cfsHome',
          component: CallcentrePortalAdminTable,
        },
        {
          path: 'search-users',
          name: 'guidanceSearchUsers',
          component: GuidanceClientSearchConfirm,
        },
        {
          path: 'manage-user',
          name: 'manageUser',
          component: MemberInfoForm,
        },
        {
          path: 'verify-members',
          name: 'verifyMembers',
          component: CallcentrePortalMemberVerification,
        },
        {
          path: 'reports',
          name: 'cfsReports',
          component: CFSBackOfficeReports,
        },
        {
          path: 'reporting',
          name: 'portalReporting',
          redirect: '/admin-portal/reporting/overview',
          component: CallcentrePortalReporting,
          children: [
            {
              path: 'overview',
              name: 'portalReportingOverview',
              component: CallcentrePortalOverview,
              meta: {
                title: 'Reporting overview',
              },
            },
            {
              path: 'engagement',
              name: 'portalReportingEngagement',
              component: CallcentrePortalEngagement,
              meta: {
                title: 'Member engagement',
              },
            },
          ],
        },
      ],
    },
  ]
}
